import { ConcretingRequestType } from "@store/graphql/helpers/types.graphql";
import { useAtom, atom } from "@libraries/jotai";

const concretingRequestsAtom = atom<ConcretingRequestType[]>([]);
const filteredConcretingRequestsAtom = atom<ConcretingRequestType[]>([]);

export default function useConcretingRequests() {
  const [value, setValue] = useAtom(concretingRequestsAtom);
  const [filteredConcretingRequests, setFilteredConcretingRequests] = useAtom(
    filteredConcretingRequestsAtom
  );

  return {
    value,
    setValue,
    filteredConcretingRequests,
    setFilteredConcretingRequests
  };
}
